import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=b3b0fe3a&scoped=true"
import script from "./Shop.vue?vue&type=script&lang=js"
export * from "./Shop.vue?vue&type=script&lang=js"
import style0 from "./Shop.vue?vue&type=style&index=0&id=b3b0fe3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b0fe3a",
  null
  
)

export default component.exports